module.exports = __webpack_public_path__ + "static/AboutVid-2ea3882d538a80645b1bdbc7810c79a3.webp";